import { normalizeChoices } from '@/utils';
import { cartLineVariablePriceValue } from '@/utils/variablePrice';

function optionKey(options) {
	return normalizeChoices(options)
		.map((option) => {
			const optionId = option.optionId || option.id || '';
			const choices = option.chosenIds || option.options || [];
			const choiceKey = choices
				.map((choice) => {
					if (typeof choice === 'string') return choice;
					const nested = Array.isArray(choice?.options)
						? choice.options.map((item) => (typeof item === 'string' ? item : item?.id || '')).sort().join(',')
						: '';
					return `${choice?.id || ''}:${choice?.comment || ''}:${nested}`;
				})
				.sort()
				.join('|');
			return `${optionId}=${choiceKey}`;
		})
		.sort()
		.join(';');
}

export function cartLineIdentityKey(product) {
	if (!product) return 'invalid-product';
	const effectiveDishClassId = product.modifyDishClass?.id ?? product.dishClass?.id ?? 'no-class';
	const sellingFormatId = product.sellingFormatId ?? 'no-format';
	const menuBatchId = product.menuBatchId ?? 'no-batch';
	const shareable = product.isShareable ? 'shareable' : 'not-shareable';
	const variablePrice = cartLineVariablePriceValue(product) ?? 'no-variable-price';
	const customName = String(product.customName ?? '').trim().toLowerCase() || 'no-custom-name';
	return [
		product.sku ?? 'no-sku',
		sellingFormatId,
		menuBatchId,
		optionKey(product.chosenOptions),
		effectiveDishClassId,
		shareable,
		variablePrice,
		customName,
	].join('_');
}

export function cartLinesMatch(first, second) {
	return cartLineIdentityKey(first) === cartLineIdentityKey(second);
}
